import { render, staticRenderFns } from "./ExtendedInfo.vue?vue&type=template&id=2c6dfe5e&scoped=true&"
import script from "./ExtendedInfo.vue?vue&type=script&lang=ts&"
export * from "./ExtendedInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendedInfo.vue?vue&type=style&index=0&id=2c6dfe5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6dfe5e",
  null
  
)

export default component.exports